import { Component } from '@theme/component';

class HexoCookiePreferences extends Component {
  #controller;
  #busy = false;
  #timer;
  #nativeObserver;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.addEventListener('click', this.#open, { signal: this.#controller.signal });
    this.#nativeObserver?.disconnect();
    this.#nativeObserver = new MutationObserver(this.#localizeNative);
    this.#nativeObserver.observe(document.body, { childList: true });
    this.#localizeNative();
    clearTimeout(this.#timer);
    let attempts = 0;
    const check = () => {
      this.hidden = !window.privacyBanner?.showPreferences;
      if (this.hidden && this.isConnected && attempts++ < 40) this.#timer = setTimeout(check, 250);
    };
    check();
  }
  disconnectedCallback() { super.disconnectedCallback(); this.#controller?.abort(); clearTimeout(this.#timer); this.#nativeObserver?.disconnect(); }
  #localizeNative = () => {
    const close = document.getElementById('shopify-pc__prefs__header-close');
    if (close && this.dataset.close) close.setAttribute('aria-label', this.dataset.close);
  };
  #open = async event => {
    const trigger = event.target.closest('[data-hx-cookie-preferences]');
    if (!trigger || event.ctrlKey || event.metaKey) return;
    event.preventDefault();
    if (this.#busy) return;
    this.#busy = true;
    trigger.setAttribute('aria-busy', 'true');
    const status = this.querySelector('[data-hx-cookie-status]');
    if (status) status.textContent = '';
    try {
      if (!window.privacyBanner?.showPreferences) throw new Error('Privacy banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      if (status && this.isConnected) status.textContent = this.dataset.error;
    } finally {
      trigger.removeAttribute('aria-busy');
      this.#busy = false;
    }
  };
}
if (!customElements.get('hexo-cookie-preferences')) customElements.define('hexo-cookie-preferences', HexoCookiePreferences);
